import React, { useCallback, useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { AppView, Button, ButtonGroup, rem, Spacer } from 'design-system';
import StatusBar from 'design-system/StatusBar';
import Text from 'design-system/Text';
import EmptyComponent from 'design-system/EmptyComponent';
import { tierThemes } from 'features/premium/benefits';
import { Tier } from 'features/premium/entities';
import { selectConnectionsLimit } from 'features/premium/selectors';
import { selectUserTier } from 'features/premium/selectors/tier';
import { useDisableAndroidBackButton } from 'hooks';
import useColors from 'hooks/useColors';
import { selectActiveConnectionsWithoutManual } from 'reducers/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import Links from 'utils/links';
import { SET_SELECTED_CONNECTIONS_BEFORE_UPGRADED_IN_LOGINS_UPGRADE_FUNNEL } from 'actions/types';
import LoginsUpgradeHelpButton from './LoginsUpgradeHelpButton';
import LoginsUpgradeBanner from './LoginsUpgradeIntroBanner';
import { allowedConnectionsInfo } from './utils';
const LoginsUpgradeIntroScreen = ({ navigation }) => {
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
            headerRight: () => <LoginsUpgradeHelpButton black/>,
            gestureEnabled: false,
            headerLeft: EmptyComponent,
            headerBackVisible: false,
        });
    }, [colors.text.primary]);
    useDisableAndroidBackButton();
    const connectionsLimitMap = useAppSelector(selectConnectionsLimit);
    const activeTier = useAppSelector(selectUserTier);
    const connections = useAppSelector(selectActiveConnectionsWithoutManual);
    const onPressSelectToKeep = useCallback(() => {
        navigation.navigate('LoginsUpgrade');
    }, []);
    const dispatch = useAppDispatch();
    const onPressUpgrade = useCallback(() => {
        navigation.navigate('EmmaProModal', {
            tier: Tier.pro,
            benefitId: 'connections',
            onUpgradeCallback: () => {
                navigation.pop();
                dispatch({
                    type: SET_SELECTED_CONNECTIONS_BEFORE_UPGRADED_IN_LOGINS_UPGRADE_FUNNEL,
                    payload: {},
                });
            },
        });
    }, []);
    const onPressWhy = useCallback(() => {
        Links.openKnownLink('whyDoINeedToSelectLogins');
    }, []);
    return (<AppView avoidHeader>
      <StatusBar barStyle="dark-content" animated/>
      <View style={styles.content}>
        <LoginsUpgradeBanner />
        <Text Text-24>{`Review your bank connections to continue using Emma`}</Text>
        <Spacer.H8 />
        <Text TextThin-16 Secondary>
          {allowedConnectionsInfo(connectionsLimitMap)}
        </Text>
        <Spacer h={10}/>
        <Text TextThin-16 Secondary>
          You are currently on {tierThemes[activeTier].name} and have {connections.length} bank connections. Please
          upgrade to remove the limits or select the bank connections you want to keep
          {activeTier === Tier.free ? ' for free' : ''}.
        </Text>
        <Spacer.H8 />
        <Text Text-16 Primary suppressHighlighting onPress={onPressWhy} testID="whyButton">
          Why are bank connections limited?
        </Text>
      </View>
      <ButtonGroup type="floating">
        <Button brandReversed title="Select the banks you want to keep" onPress={onPressSelectToKeep} testID="selectButton"/>
        <Button brand title="Upgrade for no limits" onPress={onPressUpgrade} testID="upgradeButton"/>
      </ButtonGroup>
    </AppView>);
};
const styles = StyleSheet.create({
    content: {
        flex: 1,
        paddingHorizontal: rem(16),
    },
});
export default LoginsUpgradeIntroScreen;
